import Enumerator from '../global/Enumerator';

export const objectivePaymentPlanOptions = [
  'none',
  'repayment_of_loan_prior_to_end_of_term',
  'downsizing',
  'sale_of_assets',
  'savings',
  'income_from_other_investments',
  'co_applicants_income',
  'other'
];

export class ObjectivePaymentPlanOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'repayment_of_loan_prior_to_end_of_term';
        break;
      case '2':
        correctOption = 'downsizing';
        break;
      case '3':
        correctOption = 'sale_of_assets';
        break;
      case '4':
        correctOption = 'savings';
        break;
      case '5':
        correctOption = 'income_from_other_investments';
        break;
      case '6':
        correctOption = 'co_applicants_income';
        break;
      case '7':
        correctOption = 'other';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ObjectivePaymentPlanOption.initEnum({
  none: {
    get title() {
      return 'None';
    }
  },
  repayment_of_loan_prior_to_end_of_term: {
    get title() {
      return 'Repayment of loan prior to end of term';
    }
  },
  downsizing: {
    get title() {
      return 'Downsizing';
    }
  },
  sale_of_assets: {
    get title() {
      return 'Sale of assets';
    }
  },
  savings: {
    get title() {
      return 'Savings';
    }
  },
  income_from_other_investments: {
    get title() {
      return 'Income from other investments';
    }
  },
  co_applicants_income: {
    get title() {
      return "Co-applicant's income";
    }
  },
  other: {
    get title() {
      return 'Other';
    }
  }
});

export default {
  objectivePaymentPlanOptions,
  ObjectivePaymentPlanOption
};
